import React from 'react';
import BarGraph from './Comparison/BarGraph';
import classNames from '../../utility/classNames';
import ProjectionTable from './Comparison/ProjectionTable/ProjectionTable';
import Tooltip from '../../components/Tooltip';

//component to display the summary projection graph and table for an anaylsis page
export default function SummaryProjection({
  options = [],
  setOption,
  currOption,
  setYears,
  graphData,
  tableData,
  schema,
  tableLabel,
  rehabYears,
  propertyData,
}) {
  return (
    <section className="space-y-10">
      <div className="grid grid-cols-1 w-full h-full relative mt-2 rounded-lg bg-white">
        <div className="py-4 px-6 border-b border-neutral-100 flex items-center justify-between gap-3 ">
          <h3 className="text-lg font-medium font-serif text-neutral-900">
            Projections Summary
          </h3>

          <select
            name="time"
            id="time"
            aria-label="choose time frame"
            onChange={(e) => setYears(e.target.value)}
            className="text-base pt-1 pb-[5px] h-8 rounded-md border-none max-w-lg block focus:ring-primary focus:border-primary text-black"
          >
            <option value="30">30 Years</option>
            <option value="5">5 Years</option>
            <option value="10">10 Years</option>
            <option value="15">15 Years</option>
            <option value="50">50 Years</option>
          </select>
        </div>
        <div className="p-6 pb-8">
          <div className="flex flex-wrap justify-start gap-2">
            {options?.map((option, index) => {
              return (
                <div key={index}>
                  <button
                    className={classNames(
                      'px-3 py-1 flex items-center gap-1.5 text-base font-medium rounded-full focus:outline-none',
                      options[currOption]?.name === option.name
                        ? 'text-white bg-primary-500'
                        : 'text-neutral-600 border border-neutral-300'
                    )}
                    onClick={() => setOption(index)}
                  >
                    <span className="button-content">{option.label}</span>

                    {option.description && (
                      <Tooltip
                        iconColour={
                          options[currOption]?.name === option.name
                            ? 'text-white '
                            : 'text-neutral-600'
                        }
                        text={option.description}
                        type="info"
                        offset="-left-20 -top-16"
                      />
                    )}
                  </button>
                </div>
              );
            })}
          </div>

          <div className="w-full h-[400px] p-8 flex justify-center items-center text-base">
            <BarGraph
              data={graphData}
              unit={currOption === 'ROI' ? '%' : '$'}
            />
          </div>
        </div>
      </div>

      <div className="hide-print">
        <ProjectionTable
          data={tableData}
          sectionSchema={schema}
          label={tableLabel}
          rehabYears={rehabYears}
          propertyData={propertyData}
        />
      </div>
    </section>
  );
}
